import { Box, Grid, Typography } from '@mui/material'
import { format } from 'date-fns'

import { Article } from '@ecm/data/Article'
import Anchor from '@ecm/ui/element/Anchor'
import Color from '@ecm/ui/element/Color'
import ReadMoreToggle from '@ecm/ui/element/ReadMoreToggle'

type BlogArticleSidebarLinksProps = {
  articles: Article[]
  heading: string
}

type BlogArticleSidebarItemProps = {
  article: Article
}

const getArticleItemUrl = (article: Article) => {
  if (article.redirectTo) {
    return article.redirectTo
  }
  return `/blog/${article.slug}`
}

const BlogArticleSidebarItem = ({ article }: BlogArticleSidebarItemProps) => (
  <Box borderBottom={`${Color.smoke.darker} 1px solid`} width="100%" mb="0.5em">
    <Anchor href={getArticleItemUrl(article)}>
      <Typography variant="overline" color={Color.slate.lightest} fontSize="11px">
        {format(new Date(article.publishedDate), 'MMMM d, yyyy')}
      </Typography>
      <Typography variant="h6" component="h3" mb="1em" mt="0.5em">
        {article.title}
      </Typography>
    </Anchor>
  </Box>
)
export const BlogArticleSidebarLinks = ({ articles, heading }: BlogArticleSidebarLinksProps) => (
  <Grid container flexDirection="column" mb="5em">
    <Typography variant="h5" component="h2" mb="1em">
      {heading}
    </Typography>

    <ReadMoreToggle maxHeight="650px">
      {articles.map(article => (
        <BlogArticleSidebarItem key={article.id} article={article} />
      ))}
    </ReadMoreToggle>
  </Grid>
)

export default {
  BlogSidebar: BlogArticleSidebarLinks,
}
